import React from "react";
import { Layout } from "antd5";
import classNames from "classnames";

import ActionButton from "components/actions/ActionButton";
import { MAX_SMALL_SCREEN_WARNING_SIZE } from "components/app_layout/SmallScreenWarning";
import { ScreenSize, useResponsiveScreenSize } from "lib/providers/Responsive";
import { User } from "lib/types/models";
import { performLogout } from "lib/userUtils";
import { MAY_4TH_ACTIVATION, useVariableValue } from "../../lib/featureFlags";
import VerticalNav from "./vertical_nav/VerticalNav";

import css from "./AppLayoutNavbar.module.scss";

import LogoURL from "../../../assets/images/stotles_logo.svg";
import StotlesLogoText from "../../../assets/images/stotles_logo_and_typeface_new.svg";
import TextLogo from "../../../assets/images/stotles_logo_blue.svg";
import StotlesLogo from "../../../assets/images/stotles_logo_new.svg";

function SignOutButton({ user }: { user: User | null }) {
  if (!user) {
    return null;
  }
  return (
    <ActionButton buttonType="tertiary" className={css.logoutButton} onAction={performLogout}>
      Log out
    </ActionButton>
  );
}

function Logo({ textLogo, disableNav }: { textLogo?: boolean; disableNav?: boolean }) {
  const screenSize = useResponsiveScreenSize();
  const isMayActivationEnabled = useVariableValue(MAY_4TH_ACTIVATION, false);
  const smallLogoSize = screenSize <= ScreenSize.MD;

  // show text logo if it's asked for, or if it's a non-logged in user
  const src = isMayActivationEnabled
    ? textLogo || !window.currentUser
      ? StotlesLogoText
      : StotlesLogo
    : textLogo || !window.currentUser
      ? TextLogo
      : LogoURL;
  const stotles = <img className={css.topnavLogo} src={src} alt="Stotles" />;

  return (
    <div className={css.logoWrapper}>
      {disableNav ? (
        stotles
      ) : (
        <a href={window.currentUser ? "/" : "https://www.stotles.com"}>{stotles}</a>
      )}
      {window.partner_logo_url && screenSize > MAX_SMALL_SCREEN_WARNING_SIZE && (
        <img
          src={window.partner_logo_url}
          height={smallLogoSize ? 28 : 38}
          className={css.topnavPartnerLogo}
        />
      )}
    </div>
  );
}

type Props = {
  hideNavBar?: boolean;
  hideMenuItems?: boolean;
  displayCustomAction?: React.ReactNode;
  disableLogoNav?: boolean;
  textLogo?: boolean;
};
function AppLayoutNavbar({
  hideMenuItems,
  hideNavBar,
  displayCustomAction,
  disableLogoNav,
  textLogo,
}: Props): JSX.Element {
  const { currentUser } = window;

  if (hideNavBar) {
    return <></>;
  }

  const showMenuItems = currentUser && !hideMenuItems;

  if (showMenuItems) {
    return <VerticalNav />;
  }

  return (
    <Layout.Header className={css.pageTopnav}>
      <div className={classNames(css.flexAlignCenter, css.logoAndMenu)}>
        <Logo textLogo={textLogo} disableNav={disableLogoNav} />
      </div>
      {displayCustomAction ? displayCustomAction : <SignOutButton user={currentUser} />}
    </Layout.Header>
  );
}

export default AppLayoutNavbar;
